import * as React from "react";
import * as ReactDOM from "react-dom";

import "./styles/main.scss";

import { FrontPage, FrontPageState } from "./components/";
import { defaultLocation, defaultQuestionGame, defaultUser, defaultGalleryPhoto, User } from "./models";

const defaultState: FrontPageState = {
    loading: false,
    search: { ageFrom: 18, ageTo: 80, genderMale: false, genderFemale: false, location: defaultLocation },
    questionGame: defaultQuestionGame,
    hero: Array(9).fill(defaultUser),
    online: Array(4).fill(defaultUser),
    regular: Array(4).fill(defaultUser),
    newest: Array(4).fill(defaultUser),
    popular: Array(4).fill(defaultUser),
    galleryPhotos: Array(8).fill(defaultGalleryPhoto),
    messages: null,
};

const container = document.getElementById("frontpage");
if (container !== null) {
    const stateAttribute = JSON.parse(container.getAttribute('data-initialState'));
    const props = JSON.parse(container.getAttribute('data-props'));
    const currentUser = (props.userId > 0 ? { userId: props.userId, gender: props.userGender } : null) as User;

    const initialState = {
        ...defaultState,
        ...stateAttribute,
    };

    ReactDOM.render(
        <FrontPage initialState={initialState}
            currentUser={currentUser}
            searchAgeMin={props.searchAgeMin}
            searchAgeMax={props.searchAgeMax}
            userCardVisible={props.userCardVisible}
            galleryCardVisible={props.galleryCardVisible}
            openInNewTab={props.openInNewTab} />,
        document.getElementById("frontpage")
    );
}
